import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  MatchPassword,
  noWhitespaceValidator,
  PasswordValidator,
} from '@shared/validators/form-validators';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { SharedConstants } from '@shared/model/shared-constants';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UserType } from '@shared-features/enums/user-type.enum';
import { UsersCommonApiService } from '@shared-features/services/users-common-api.service';

@Component({
  selector: 'app-reset-password-modal',
  templateUrl: './reset-password-modal.component.html',
  styleUrls: ['./reset-password-modal.component.scss'],
})
export class ResetPasswordModalComponent extends BaseComponent implements OnInit {
  public displayPassword = false;
  public displayConfirmPassword = false;

  @ViewChild('resetPasswordModal') resetPasswordModal;
  @Input() id: number;
  @Input() name: string;
  @Input() showModal: Observable<void>;
  @Output() closeModal = new EventEmitter();

  form: UntypedFormGroup;
  sharedConstants = SharedConstants;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private usersCommonApiService: UsersCommonApiService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initForm();
    this.showModal.subscribe((value: any) => {
      if (value) this.resetPasswordModal.showModal();
    });
  }

  initForm() {
    this.form = this.formBuilder.group(
      {
        password: new UntypedFormControl('', [
          Validators.required,
          noWhitespaceValidator,
          PasswordValidator,
        ]),
        confirmPassword: new UntypedFormControl('', [
          Validators.required,
          noWhitespaceValidator,
          PasswordValidator,
        ]),
      },
      { validator: MatchPassword }
    );
  }

  onCancelClicked() {
    this.closeModal.emit();
    this.resetPasswordModal.closeModal();
    this.form.reset();
  }

  onSendClicked() {
    this.load(
      this.usersCommonApiService.resetPassword({
        id: this.id,
        type: UserType.DRIVER,
        password: this.form.value['password'],
      }),
      { isLoadingTransparent: true, fetchOnce: true }
    )
      .pipe(finalize(() => this.onCancelClicked()))
      .subscribe(() => {
        this.asyncFeedbackService.showSuccessMessage(
          this.translationsList['SuccessMessages']['PasswordResetSuccessfully']
        );
      });
  }
}
